// Ekran kabuğu sekmeleri — bir ekranın alt görünümlerini bildiren TEK liste.
//
// Dosya İKİ tüketiciye hizmet eder ve bu bilinçlidir: kabuk bileşeni şeridi bu
// listeden çizer, `store/tabs.ts` aynı listeden "bu adresler tek ekrandır"
// kuralını türetir (SEM-7196). Liste iki yere yazılsaydı biri bayatlardı ve
// şeritte görünen bir alt görünüm sessizce kendi üst sekmesini açardı.
//
// Buraya YALNIZ ortak gezinmenin alt görünümleri yazılır. Ayrı kayıt ve form
// rotaları (`/assets/:id`, `/assets/new`) kendi kimliğini taşır; sabitleme ve
// önizleme davranışını `store/tabs.ts` belirler.
//
// Kökten sonraki sekme yan menüde KENDİ girdisi olan bir adres olamaz. Sayfa
// içi sekme menüdeki başka bir ekrana atlatınca kullanıcı bulunduğu ekranı
// kaybediyor ve menüde iki ayrı yoldan aynı yere varıyordu (kullanıcı geri
// bildirimi, 2026-10-16). Katalog bu yüzden şeritte yok; bordro ekranlarının
// sayfa içi şeridi de kaldırıldı.

import { MENU_SECTIONS, menuLinks } from "./menu-config";

/** Kabuğun bir alt görünümü. */
export interface ShellTab {
  /** Mutlak rota. Grubun İLK satırı ekranın kökü ve index sekmesidir. */
  readonly to: string;
  readonly labelKey: string;
  /** Yalnız index sekmesi `end` ister; yoksa kardeşlerinde de aktif kalır. */
  readonly end?: boolean;
}

export const ASSETS_SHELL_TABS: readonly ShellTab[] = [
  { to: "/assets", labelKey: "assets.tab_inventory", end: true },
  { to: "/assets/stock", labelKey: "assets.tab_stock" },
  { to: "/assets/assignments", labelKey: "assets.tab_history" },
  { to: "/assets/audits", labelKey: "assets.audit.tab" },
];

export const BENEFITS_SHELL_TABS: readonly ShellTab[] = [
  { to: "/benefits", labelKey: "benefits.tab_plans", end: true },
  { to: "/benefits/enrollments", labelKey: "benefits.tab_enrollments" },
  { to: "/benefits/carriers", labelKey: "benefits.tab_carriers" },
];

export const SURVEYS_SHELL_TABS: readonly ShellTab[] = [
  { to: "/surveys", labelKey: "surveys.tab_surveys", end: true },
  { to: "/surveys/templates", labelKey: "surveys.tab_templates" },
  { to: "/surveys/pulse", labelKey: "surveys.tab_pulse" },
];

// `/onboarding/plans/new` ve `/onboarding/plans/:planId` bu listede YOKTUR.
// Onlar kabuğun kardeşidir: form ekranı şeridi taşımaz ve kendi üst sekmesini
// açar. Rota sıralaması da bunu ayırır — düz `plans` yalnız kendi adresini
// eşler, `plans/new` daha özgüldür.
export const ONBOARDING_SHELL_TABS: readonly ShellTab[] = [
  { to: "/onboarding", labelKey: "onboarding.tab_in_flight", end: true },
  { to: "/onboarding/terminal", labelKey: "onboarding.tab_terminal" },
  { to: "/onboarding/plans", labelKey: "onboarding.tab_plans" },
];

// Bordro grubu ŞERİT DEĞİLDİR; yalnız üst sekme kimliğini paylaştırır. Sayfa
// içi bordro gezinmesi kalktı, ama bordro ekranları arasında dolaşan kullanıcı
// yine tek bir üst sekmede kalır (e260e3e9 sabitli sekme kararı).
export const PAYROLL_SHELL_TABS: readonly ShellTab[] = MENU_SECTIONS
  .filter((section) => section.key === "payroll-management")
  .flatMap((section) => menuLinks(section.items).map((item, index) => ({
    to: item.href,
    labelKey: item.labelKey,
    ...(index === 0 ? { end: true } : {}),
  })));

/** Sayfa içinde `ShellTabsNav` ile çizilen şeritler. */
export const RENDERED_SHELL_STRIPS: readonly (readonly ShellTab[])[] = [
  ASSETS_SHELL_TABS,
  BENEFITS_SHELL_TABS,
  SURVEYS_SHELL_TABS,
  ONBOARDING_SHELL_TABS,
];

/** Kabuk kümesi. Bir grubun sekmeleri üst şeritte TEK sekme paylaşır. */
export const SHELL_TAB_GROUPS: readonly (readonly ShellTab[])[] = [
  ...RENDERED_SHELL_STRIPS,
  PAYROLL_SHELL_TABS,
];
